import { mapState } from 'vuex';
import * as rrweb from 'rrweb';
import closeAccountModal from '@/views/system/accountManage/closeAccountModal.vue';
export default {
  name: 'navUser',
  components: {
    closeAccountModal
  },
  data() {
    return {
      visibleModal: false
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  methods: {
    async logout() {
      await this.$store.dispatch('user/logout');
      // this.$store.dispatch('user/setUploadTrackback');
      clearInterval();
      // let stopFn = rrweb.record({
      //   emit(event) {
      //     setTimeout(() => {
      //       stopFn();
      //     }, 100);
      //   }
      // });
      await this.$store.dispatch('tagsView/clearTag');
      this.$router.replace({
        path: '/login'
      });
      sessionStorage.removeItem('loginTime');
      sessionStorage.removeItem('loginRandomId');
      // commit('SET_TOKEN', '');
      // commit('SET_USERINFO', '');
      // removeCache('TOKEN');
      // resetRouter();
      // resolve();
      // // await this.$store.dispatch('user/logout');
      // await this.$store.dispatch('tagsView/clearTag');
      // this.$router.replace({
      //   path: '/login'
      // });
    },
    closeAccountCli() {
      this.visibleModal = true;
    }
  }
};